export default __webpack_public_path__ + "static/Contacts-min-2969f0628a0ffb78c28fc43f8c32f0d7.jpg";